/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _toConsumableArray } from '../../_chunks/dep-fd3498b6.js';
import React from 'react';
import { AddIcon, BrowseIcon, DeleteIcon, ErrorCircleFilledIcon } from 'tdesign-icons-react';
import classNames from 'classnames';
import { Loading } from '../../loading/index.js';
import useGlobalIcon from '../../hooks/useGlobalIcon.js';
import { ImageViewer } from '../../image-viewer/index.js';
import { abridgeName } from '../../_common/js/upload/utils.js';
import '../../_chunks/dep-2acfafca.js';
import '../../loading/Loading.js';
import '../../_chunks/dep-46de7b2e.js';
import '../../_chunks/dep-e43cf21c.js';
import '../../_util/dom.js';
import 'raf';
import '../../_chunks/dep-6c5254c6.js';
import '../../_chunks/dep-c3f1141e.js';
import '../../_chunks/dep-4941ebe7.js';
import '../../_chunks/dep-e9b62d1f.js';
import '../../_chunks/dep-77e34309.js';
import '../../_chunks/dep-7dce2c26.js';
import '../../_util/easing.js';
import '../../hooks/useConfig.js';
import '../../config-provider/ConfigContext.js';
import '../../_chunks/dep-d71ee5f3.js';
import '../../_chunks/dep-4b8f240e.js';
import '../../_chunks/dep-9acbc163.js';
import '../../_chunks/dep-7b52f080.js';
import '../../_chunks/dep-f10515e8.js';
import '../../_chunks/dep-88cd50bf.js';
import '../../_chunks/dep-dcb5aa2a.js';
import '../../_chunks/dep-ee4bf8c2.js';
import '../../_chunks/dep-934eda0c.js';
import '../../_chunks/dep-12510d64.js';
import '../../_chunks/dep-6b568d83.js';
import '../../_chunks/dep-304e657b.js';
import '../../_chunks/dep-6506fbc2.js';
import '../../_chunks/dep-bb5d7b1e.js';
import '../../_chunks/dep-e285f2f8.js';
import '../../_chunks/dep-f4a320cd.js';
import '../../_chunks/dep-ec70b95c.js';
import '../../locale/zh_CN.js';
import '../../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../../_chunks/dep-cbcc9f89.js';
import '../../_common/js/global-config/default-config.js';
import '../../common/Portal.js';
import 'react-dom';
import '../../loading/gradient.js';
import '../../hooks/useDomRefCallback.js';
import '../../_common/js/loading/circle-adapter.js';
import '../../_common/js/utils/set-style.js';
import '../../_common/js/utils/helper.js';
import '../../_chunks/dep-92728dc5.js';
import '../../_chunks/dep-ec16db36.js';
import '../../_chunks/dep-036ad2cc.js';
import '../../_chunks/dep-0e15088f.js';
import '../../loading/defaultProps.js';
import '../../loading/plugin.js';
import '../../_util/react-render.js';
import '../../_chunks/dep-e0370ebe.js';
import '../../loading/style/css.js';
import '../../loading/type.js';
import '../../image-viewer/ImageViewer.js';
import '../../_chunks/dep-10388ab5.js';
import '../../tooltip/index.js';
import '../../tooltip/Tooltip.js';
import '../../popup/index.js';
import '../../popup/Popup.js';
import 'react-transition-group';
import 'react-popper';
import '../../hooks/useControlled.js';
import '../../_chunks/dep-f721d103.js';
import '../../_chunks/dep-4559db64.js';
import '../../_chunks/dep-c00532d4.js';
import '../../_chunks/dep-33ffecad.js';
import '../../_chunks/dep-c1f93350.js';
import '../../_util/noop.js';
import '../../_util/useAnimation.js';
import '../../hooks/usePrevious.js';
import '../../popup/hooks/useTrigger.js';
import 'react-is';
import '../../popup/utils/ref.js';
import '../../_util/composeRefs.js';
import '../../popup/utils/transition.js';
import '../../_util/useMutationObserver.js';
import '../../_chunks/dep-01ce608f.js';
import '../../_chunks/dep-77a54538.js';
import '../../_util/useWindowSize.js';
import '../../popup/defaultProps.js';
import '../../popup/style/css.js';
import '../../popup/type.js';
import '../../tooltip/defaultProps.js';
import '../../tooltip/TooltipLite.js';
import '../../_util/useSwitch.js';
import '../../_util/usePersistFn.js';
import '../../_common/js/utils/getPosition.js';
import '../../tooltip/style/css.js';
import '../../tooltip/type.js';
import '../../locale/LocalReceiver.js';
import '../../config-provider/index.js';
import '../../config-provider/ConfigProvider.js';
import '../../image-viewer/utils.js';
import '../../dialog/index.js';
import '../../dialog/Dialog.js';
import '../../_util/useSetState.js';
import '../../dialog/defaultProps.js';
import '../../dialog/DialogCard.js';
import '../../button/index.js';
import '../../button/Button.js';
import '../../_util/useRipple.js';
import '../../_util/setStyle.js';
import '../../button/defaultProps.js';
import '../../_util/parseTNode.js';
import '../../button/style/css.js';
import '../../button/type.js';
import '../../dialog/hooks/useDialogEsc.js';
import '../../dialog/hooks/useLockStyle.js';
import '../../_util/useLayoutEffect.js';
import '../../_common/js/utils/getScrollbarWidth.js';
import '../../dialog/hooks/useDialogPosition.js';
import '../../dialog/hooks/useDialogDrag.js';
import '../../dialog/utils.js';
import '../../_common/js/log/index.js';
import '../../_common/js/log/log.js';
import '../../dialog/plugin.js';
import '../../dialog/style/css.js';
import '../../dialog/type.js';
import '../../image-viewer/hooks/useMirror.js';
import '../../image-viewer/hooks/usePosition.js';
import '../../image-viewer/hooks/useIndex.js';
import '../../image-viewer/hooks/useRotate.js';
import '../../image-viewer/hooks/useScale.js';
import '../../image-viewer/hooks/useIconMap.js';
import '../../image-viewer/defaultProps.js';
import '../../image-viewer/hooks/useImageScale.js';
import '../../image-viewer/hooks/useList.js';
import '../../image-viewer/hooks/useViewerScale.js';
import '../../image-viewer/style/css.js';

var ImageCard = function ImageCard(props) {
  var _locale$triggerUpload;
  var displayFiles = props.displayFiles,
    locale = props.locale,
    classPrefix = props.classPrefix,
    multiple = props.multiple,
    _props$max = props.max,
    max = _props$max === void 0 ? 0 : _props$max,
    onRemove = props.onRemove,
    disabled = props.disabled;
  var _useGlobalIcon = useGlobalIcon({
      AddIcon: AddIcon,
      BrowseIcon: BrowseIcon,
      DeleteIcon: DeleteIcon,
      ErrorCircleFilledIcon: ErrorCircleFilledIcon
    }),
    BrowseIcon$1 = _useGlobalIcon.BrowseIcon,
    DeleteIcon$1 = _useGlobalIcon.DeleteIcon,
    AddIcon$1 = _useGlobalIcon.AddIcon,
    ErrorCircleFilledIcon$1 = _useGlobalIcon.ErrorCircleFilledIcon;
  var showTrigger = React.useMemo(function () {
    if (multiple) {
      return !max || displayFiles.length < max;
    }
    return !(displayFiles !== null && displayFiles !== void 0 && displayFiles[0]);
  }, [displayFiles, max, multiple]);
  var renderMainContent = function renderMainContent(file, index) {
    return /* @__PURE__ */React.createElement("div", {
      className: "".concat(classPrefix, "-upload__card-content ").concat(classPrefix, "-upload__card-box")
    }, /* @__PURE__ */React.createElement("img", {
      className: "".concat(classPrefix, "-upload__card-image"),
      src: file.url
    }), /* @__PURE__ */React.createElement("div", {
      className: "".concat(classPrefix, "-upload__card-mask")
    }, /* @__PURE__ */React.createElement("span", {
      className: "".concat(classPrefix, "-upload__card-mask-item"),
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    }, /* @__PURE__ */React.createElement(ImageViewer, {
      trigger: function trigger(_ref) {
        var onOpen = _ref.onOpen;
        return /* @__PURE__ */React.createElement(BrowseIcon$1, {
          onClick: function onClick(e) {
            var _props$onPreview;
            (_props$onPreview = props.onPreview) === null || _props$onPreview === void 0 ? void 0 : _props$onPreview.call(props, {
              file: file,
              index: index,
              e: e
            });
            onOpen();
          }
        });
      },
      images: displayFiles.map(function (t) {
        return t.url;
      }),
      defaultIndex: index
    })), !disabled && /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement("span", {
      className: "".concat(classPrefix, "-upload__card-mask-item-divider")
    }), /* @__PURE__ */React.createElement("span", {
      className: "".concat(classPrefix, "-upload__card-mask-item"),
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    }, /* @__PURE__ */React.createElement(DeleteIcon$1, {
      onClick: function onClick(e) {
        return onRemove === null || onRemove === void 0 ? void 0 : onRemove({
          e: e,
          file: file,
          index: index
        });
      }
    })))));
  };
  var renderProgressFile = function renderProgressFile(file, loadCard) {
    var _locale$progress;
    return /* @__PURE__ */React.createElement("div", {
      className: classNames([loadCard, "".concat(classPrefix, "-upload__").concat(props.theme, "-").concat(file.status)])
    }, /* @__PURE__ */React.createElement(Loading, {
      loading: true,
      size: "medium"
    }), /* @__PURE__ */React.createElement("p", null, locale === null || locale === void 0 ? void 0 : (_locale$progress = locale.progress) === null || _locale$progress === void 0 ? void 0 : _locale$progress.uploadingText, props.showUploadProgress ? " ".concat(file.percent, "%") : ""));
  };
  var renderFailFile = function renderFailFile(file, index, loadCard) {
    var _file$response, _locale$progress2;
    return /* @__PURE__ */React.createElement("div", {
      className: loadCard
    }, /* @__PURE__ */React.createElement(ErrorCircleFilledIcon$1, null), /* @__PURE__ */React.createElement("p", null, ((_file$response = file.response) === null || _file$response === void 0 ? void 0 : _file$response.error) || (locale === null || locale === void 0 ? void 0 : (_locale$progress2 = locale.progress) === null || _locale$progress2 === void 0 ? void 0 : _locale$progress2.failText)), /* @__PURE__ */React.createElement("div", {
      className: "".concat(classPrefix, "-upload__card-mask")
    }, /* @__PURE__ */React.createElement("span", {
      className: "".concat(classPrefix, "-upload__card-mask-item"),
      onClick: function onClick(e) {
        return e.stopPropagation();
      }
    }, /* @__PURE__ */React.createElement(DeleteIcon$1, {
      onClick: function onClick(e) {
        var _props$onRemove;
        return (_props$onRemove = props.onRemove) === null || _props$onRemove === void 0 ? void 0 : _props$onRemove.call(props, {
          e: e,
          file: file,
          index: index
        });
      }
    }))));
  };
  var cardItemClasses = "".concat(classPrefix, "-upload__card-item ").concat(classPrefix, "-is-background");
  return /* @__PURE__ */React.createElement("div", null, /* @__PURE__ */React.createElement("ul", {
    className: "".concat(classPrefix, "-upload__card")
  }, displayFiles === null || displayFiles === void 0 ? void 0 : displayFiles.map(function (file, index) {
    var loadCard = "".concat(classPrefix, "-upload__card-container ").concat(classPrefix, "-upload__card-box");
    var fileName = props.abridgeName ? abridgeName.apply(void 0, [file.name].concat(_toConsumableArray(props.abridgeName))) : file.name;
    return /* @__PURE__ */React.createElement("li", {
      className: cardItemClasses,
      key: index
    }, file.status === "progress" && renderProgressFile(file, loadCard), file.status === "fail" && renderFailFile(file, index, loadCard), !["progress", "fail"].includes(file.status) && file.url && renderMainContent(file, index), /* @__PURE__ */React.createElement("div", {
      className: "".concat(classPrefix, "-upload__card-name")
    }, fileName));
  }), showTrigger && /* @__PURE__ */React.createElement("li", {
    className: cardItemClasses,
    onClick: props.triggerUpload
  }, /* @__PURE__ */React.createElement("div", {
    className: "".concat(classPrefix, "-upload__image-add ").concat(classPrefix, "-upload__card-container ").concat(classPrefix, "-upload__card-box")
  }, /* @__PURE__ */React.createElement(AddIcon$1, null), /* @__PURE__ */React.createElement("p", {
    className: "".concat(classPrefix, "-size-s")
  }, locale === null || locale === void 0 ? void 0 : (_locale$triggerUpload = locale.triggerUploadText) === null || _locale$triggerUpload === void 0 ? void 0 : _locale$triggerUpload.image)))));
};
ImageCard.displayName = "ImageCard";

export { ImageCard as default };
//# sourceMappingURL=ImageCard.js.map
